import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListResponsibles } from "../../../components/Admin/Responsibles";
import "./Responsibles.scss";
import { useLanguage } from "../../../contexts";

export function Responsibles() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("active_responsibles"), render: () => (<Tab.Pane attached={false}><ListResponsibles responsiblesActive={true} reload={reload} onReload={onReload} /></Tab.Pane>) },
    { menuItem: t("inactive_responsibles"), render: () => (<Tab.Pane attached={false}><ListResponsibles responsiblesActive={false} reload={reload} onReload={onReload} /></Tab.Pane>) },
  ];

  return (
    <div className="responsibles-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="responsibles-page-header-wrapper">
        <div className="responsibles-page-header">
          <span className="responsibles-page-title">{t("responsibles")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
